import React from 'react';
import { Eye, MessageCircle } from 'lucide-react';

export default function ProductCard({ product, colors, setSelectedProduct, sendWhatsApp, accentColor }) {
  return (
    <div
      className="bg-white rounded-2xl md:rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:transform hover:-translate-y-2 border border-purple-100 flex flex-col"
      style={accentColor ? { borderColor: `${accentColor}30` } : {}}
    >
      <div
        className="relative h-40 md:h-64 bg-gradient-to-br from-purple-100 to-pink-100 flex items-center justify-center overflow-hidden cursor-pointer"
        onClick={() => setSelectedProduct(product)}
        style={accentColor ? { background: `linear-gradient(135deg, ${accentColor}10, ${accentColor}20)` } : {}}
      >
        <img
          src={product.imagen}
          alt={product.nombre}
          loading="lazy"
          className="h-full w-auto object-contain"
        />

        {(() => {
          if (product.discount > 0 && product.discountEndDate) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const endDate = new Date(product.discountEndDate + 'T00:00:00');
            endDate.setHours(0, 0, 0, 0);
            if (endDate >= today) {
              return (
                <div className="absolute top-2 right-2 md:top-4 md:right-6 z-10 scale-[0.7] md:scale-100 origin-top-right">
                  <div className="relative border-4 border-[#065f46] bg-transparent text-[#065f46] px-4 py-2 rounded-xl flex flex-col items-center justify-center min-w-[80px] aspect-[4/2.4] shadow-[0_0_15px_rgba(255,255,255,0.8)]">
                    {/* Triangle for speech bubble */}
                    <div
                      className="absolute -right-[14px] top-1/2 -translate-y-1/2 w-0 h-0 border-y-[10px] border-y-transparent border-l-[12px] border-l-[#065f46]"
                    ></div>

                    <span
                      className="text-2xl md:text-3xl font-black leading-none"
                      style={{ textShadow: '0 0 10px rgba(255,255,255,0.9), 0 0 5px rgba(255,255,255,0.9)' }}
                    >
                      {product.discount}%
                    </span>
                    <span
                      className="text-[10px] md:text-[12px] font-semibold tracking-widest mt-1 leading-none"
                      style={{ textShadow: '0 0 8px rgba(255,255,255,0.9)' }}
                    >
                      DESCUENTO
                    </span>
                  </div>
                </div>
              );
            }
          }
          return null;
        })()}

        {/* favorites removed */}
      </div>

      <div className="p-3 md:p-6 flex flex-col flex-grow">
        <div className="flex items-start justify-between mb-2 md:mb-3">
          <div className="flex-1">
            <p className="text-xs md:text-sm text-purple-600 font-semibold mb-1" style={accentColor ? { color: accentColor } : {}}>{product.linea}</p>
            <h3 className="text-sm md:text-xl font-bold text-gray-800 line-clamp-2 leading-tight">{product.nombre}</h3>
          </div>
          {
            (() => {
              const colorValues = Array.isArray(product.color) ? product.color : product.color ? [product.color] : [];
              if (colorValues.length === 0) return null;
              return (
                <div className="flex items-center gap-1 md:gap-2 ml-2 md:ml-3 flex-shrink-0">
                  {colorValues.map((c) => {
                    const meta = colors[c] || {};
                    return (
                      <span
                        key={c}
                        className="w-4 h-4 md:w-6 md:h-6 rounded-full border-2 border-white shadow-lg"
                        style={{ backgroundColor: meta.hex || '#e5e7eb' }}
                        title={meta.name || c}
                      ></span>
                    );
                  })}
                </div>
              );
            })()
          }
        </div>

        <div className="flex gap-2 md:gap-3 mt-auto pt-3 md:pt-4">
          <button
            onClick={() => setSelectedProduct(product)}
            className={`flex-1 flex items-center justify-center gap-2 px-0 py-2 md:px-4 md:py-3 rounded-xl md:rounded-2xl font-semibold transition-all duration-200 ${!accentColor ? 'bg-purple-100 hover:bg-purple-200 text-purple-700' : 'bg-gray-100 hover:bg-gray-200'}`}
            style={accentColor ? { color: accentColor } : {}}
            title="Ver Detalles"
          >
            <Eye className="w-4 h-4 md:w-5 md:h-5" />
            <span className="hidden md:inline">Detalles</span>
          </button>

          <button
            onClick={() => sendWhatsApp(product)}
            className={`flex-1 flex items-center justify-center gap-2 px-0 py-2 md:px-4 md:py-3 text-white rounded-xl md:rounded-2xl font-semibold transition-all duration-200 shadow-md ${!accentColor ? 'bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700' : ''}`}
            style={accentColor ? { backgroundColor: accentColor } : {}}
            title="Consultar por WhatsApp"
          >
            <MessageCircle className="w-4 h-4 md:w-5 md:h-5" />
            <span className="hidden md:inline">WhatsApp</span>
          </button>
        </div>
      </div>
    </div>
  );
}
